/* src/app/modules/dna-syngovia/components/dna-syngovia-customer-overview/dna-syngovia-customer-overview.component.scss */
:host {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.map-container {
  width: 100%;
  text-align: center;
}
/*# sourceMappingURL=dna-syngovia-customer-overview.component.css.map */
